<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.663 3.77354C13.8902 2.98364 11.9096 2.78796 10.0166 3.21567C8.12351 3.64338 6.41942 4.67157 5.15845 6.1469C3.89749 7.62223 3.14721 9.46565 3.01951 11.4022C2.89181 13.3388 3.39354 15.2648 4.44987 16.8929C5.50619 18.521 7.06051 19.7641 8.88102 20.4367C10.7015 21.1092 12.6907 21.1753 14.5518 20.625C16.413 20.0748 18.0464 18.9376 19.2084 17.3832C20.3705 15.8287 20.9989 13.9403 21 11.9995V11.0801C21 10.5278 21.4477 10.0801 22 10.0801C22.5523 10.0801 23 10.5278 23 11.0801V12.0001C22.9986 14.3722 22.2306 16.6808 20.8103 18.5807C19.39 20.4806 17.3936 21.8704 15.1189 22.543C12.8442 23.2155 10.413 23.1348 8.18792 22.3127C5.96285 21.4907 4.06312 19.9714 2.77206 17.9815C1.48099 15.9915 0.86777 13.6376 1.02384 11.2706C1.17992 8.9037 2.09693 6.65064 3.63811 4.84746C5.17929 3.04428 7.26206 1.7876 9.57581 1.26484C11.8896 0.742082 14.3103 0.981252 16.477 1.94668C16.9815 2.17146 17.2082 2.76264 16.9834 3.26711C16.7587 3.77158 16.1675 3.99832 15.663 3.77354Z"
      fill="var(--wp-text-success)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.7068 3.29254C23.0975 3.68287 23.0978 4.31603 22.7075 4.70675L12.7075 14.7168C12.52 14.9044 12.2656 15.0099 12.0002 15.01C11.7349 15.0101 11.4805 14.9047 11.2929 14.7171L8.29289 11.7171C7.90237 11.3266 7.90237 10.6934 8.29289 10.3029C8.68342 9.91237 9.31658 9.91237 9.70711 10.3029L11.9996 12.5954L21.2925 3.29325C21.6829 2.90253 22.316 2.90221 22.7068 3.29254Z"
      fill="var(--wp-text-success)"
    />
  </svg>
</template>
